/**
 * A modal dialog surface — a Radix `Dialog` (`role="dialog"`) or `AlertDialog`
 * (`role="alertdialog"`) whose `data-state` is `open`. Both are the stable ARIA
 * contract Radix always renders; `data-state="open"` excludes the dialog mid
 * close-animation.
 */
const OPEN_MODAL_DIALOG_SELECTOR =
  '[role="dialog"][data-state="open"],[role="alertdialog"][data-state="open"]'

/** The selector itself, for a MutationObserver that waits on it. */
export { OPEN_MODAL_DIALOG_SELECTOR }

/**
 * True when a modal dialog is open anywhere in `doc`. Shared since the feed
 * spotlight host also waits on it (a popup never lands on an open dialog). Used to keep the forms
 * selection alive while the type-to-confirm delete dialog is up: that dialog's dim
 * backdrop overlay is a bare `<div>` (no `role`, no marker) rendered as a sibling
 * of the dialog content, so a press on it can't be recognised by target-matching.
 * But while a modal is open every press necessarily lands on the modal — its
 * content or its full-screen backdrop — never the list behind it, so the press
 * must never clear the selection.
 */
export function isOpenModalDialogPresent(doc: Document): boolean {
  return doc.querySelector(OPEN_MODAL_DIALOG_SELECTOR) !== null
}
